export default [
	{ type: 0, label: 'Bicycle', icon: 'bike', color: '' },
	{ type: 1, label: 'Motorcycle', icon: 'bike', color: '' },
	{ type: 2, label: 'Car', icon: 'bike', color: '' },
	// { type: 0, label: 'Bicycle', icon: 'bicycle', color: 'text-success' },
	// { type: 1, label: 'Motorcycle', icon: 'motorcycle', color: 'text-primary' },
	// { type: 2, label: 'Car', icon: 'cab', color: '' },
];
